var map = {
	"./en.json": 420,
	"./fi.json": 421,
	"./sv.json": 422
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*\.json$
// module id = 419
// module chunks = 0